import { getStructuralDescendentIds } from './getStructuralDescendentIds.js';

export const expandWorkflowFolderStepIds = ({ graph, steps = [], stepIds = [] }) => {
  const stepById = new Map((steps || []).map((step) => [step.id, step]));
  const expandedStepIds = [];
  const seen = new Set();

  const addStepId = (stepId) => {
    if (!stepId || seen.has(stepId) || !stepById.has(stepId)) {
      return;
    }

    seen.add(stepId);
    expandedStepIds.push(stepId);

    const step = stepById.get(stepId);
    if (step?.appSlug !== 'folder') {
      return;
    }

    for (const childId of getStructuralDescendentIds(graph, stepId)) {
      addStepId(childId);
    }
  };

  for (const stepId of stepIds || []) {
    addStepId(stepId);
  }

  return expandedStepIds;
};
